import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@app/core/components/confirm-dialog/confirm-dialog.component';
import { ClientService } from '@app/core/services/client.service';
import { DialogProviderService } from '@app/core/services/dialog-provider.service';
import { Client } from '@app/core/types/client';
import { TranslateService } from '@ngx-translate/core';
import { filter, switchMap } from 'rxjs';

@Component({
  selector: 'itfg-id-card-verification-status',
  templateUrl: './id-card-verification-status.component.html',
  styleUrl: './id-card-verification-status.component.scss',
  standalone: false,
})
export class IdCardVerificationStatusComponent {
  @Input() client: Client;

  constructor(
    public translate: TranslateService,
    private dialogService: DialogProviderService,
    private clientService: ClientService

  ) { }

  get verified(): boolean {
    return this.client?.idCardVerified ?? false;
  }

  openEditVerificationConfirmation(isVerified: boolean): MatDialogRef<ConfirmDialogComponent> {

    return this.dialogService.openConfirm({
      message: this.translate.instant(isVerified ? 'verification.id.idInvalidationConfirmationMessage' : 'verification.id.idVerificationConfirmationMessage'),
      cancelButton: this.translate.instant('global.cancel'),
      acceptButton: this.translate.instant('global.confirm'),
      width: '500px',
    });
  }

  editVerificationStatus() {
    const confirmationDialog = this.openEditVerificationConfirmation(this.verified);
    confirmationDialog.afterClosed()
      .pipe(
        filter(success => !!success),
        switchMap(() => this.clientService.changeVerificationStatus$(this.client.id, !this.verified))
      )
      .subscribe({
        next: (res) => {
          this.clientService.onClientDataChange.next(res);
        },
        error: (e) => {
          console.error(e)
        }
      })

  }
}